module.exports = __webpack_public_path__ + "static/img/light.669bd54.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/media5/light.png
// module id = 3iIC
// module chunks = 7